import {
  EmploymentType,
  HoursPerWeek,
  ProfessionExperienceLevel,
  RemoteWork,
  SalaryAmountType,
  Shift,
  VacancyCandidates,
} from './VacancyEnums';

export interface VacancyWorkExperienceInfoModel {
  vacancy_id: string | null;
  work_experience_level: ProfessionExperienceLevel;
}

export interface VacancyWorkHoursModel {
  vacancy_id: string | null;
  work_hours: HoursPerWeek;
}

export interface VacancyWorkShiftModel {
  vacancy_id: string | null;
  work_shifts: Shift[] | null;
}

export interface VacancyWorkNumberOfCandidatesModel {
  vacancy_id: string | null;
  candidates: VacancyCandidates;
}

export interface VacancyWorkEmploymentTypeModel {
  vacancy_id: string | null;
  type: EmploymentType;
}

export interface VacancyWorkSalaryModel {
  vacancy_id: string | null;
  type: SalaryAmountType;
  hourly_wage: number | null;
  salary_range_min: number | null;
  salary_range_max: number | null;
  currency: string | null;
}

export interface VacancyWorkLocationModel {
  vacancy_id: string | null;
  location: string | null;
}

export interface VacancyWorkRemoteWorkModel {
  vacancy_id: string | null;
  remote_work: RemoteWork;
}

export interface VacancyCompanyBonusesModel {
  vacancy_id: string | null;
  company_bonuses: string[] | null;
}
